import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, Mail } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { PHONE, PHONE_TEL, ADDRESS, MAPS_LINK, EMAIL, INSTAGRAM_URL, FACEBOOK_URL, ASSETS } from "../data/constants";

const Footer = () => {
    const { t } = useLang();
    return (
        <footer data-testid="footer" className="bg-aegean-800 text-white relative overflow-hidden">
            {/* decorative waves */}
            <svg
                aria-hidden="true"
                className="absolute -bottom-12 left-0 right-0 w-full opacity-10"
                viewBox="0 0 1440 200"
                fill="none"
            >
                <path
                    d="M0,100 Q360,40 720,100 T1440,100 L1440,200 L0,200 Z"
                    fill="white"
                />
                <path
                    d="M0,140 Q360,80 720,140 T1440,140"
                    stroke="white"
                    strokeWidth="2"
                    fill="none"
                    opacity="0.6"
                />
            </svg>

            <div className="container-x py-16 md:py-20 grid md:grid-cols-4 gap-12 relative z-10">
                <div className="md:col-span-2">
                    <img
                        src={ASSETS.logoBlue}
                        alt="AMOS Beach Bar"
                        data-testid="footer-logo"
                        className="h-20 w-auto object-contain brightness-0 invert"
                    />
                    <div className="mt-4 text-xs font-display uppercase tracking-[0.32em] text-aegean-200">
                        {t("footer.tagline")}
                    </div>
                    <p className="mt-6 max-w-md text-white/70 text-sm leading-relaxed">
                        {t("about.body")}
                    </p>
                    <div className="mt-6 flex gap-3">
                        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full border border-white/30 grid place-items-center hover:bg-white hover:text-aegean-700 transition" data-testid="instagram-link">
                            <Instagram size={16} />
                        </a>
                        <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full border border-white/30 grid place-items-center hover:bg-white hover:text-aegean-700 transition" data-testid="facebook-link">
                            <Facebook size={16} />
                        </a>
                    </div>
                </div>
                <div>
                    <h4 className="font-display uppercase tracking-[0.28em] text-xs text-aegean-200 mb-5">
                        {t("footer.nav")}
                    </h4>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/" className="hover:text-aegean-300">{t("nav.home")}</Link></li>
                        <li><Link to="/menu" className="hover:text-aegean-300">{t("nav.menu")}</Link></li>
                        <li><Link to="/events" className="hover:text-aegean-300">{t("nav.events")}</Link></li>
                        <li><Link to="/location" className="hover:text-aegean-300">{t("nav.location")}</Link></li>
                        <li><Link to="/contact" className="hover:text-aegean-300">{t("nav.contact")}</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-display uppercase tracking-[0.28em] text-xs text-aegean-200 mb-5">
                        {t("footer.contact")}
                    </h4>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-2">
                            <Phone size={14} className="mt-1 shrink-0" />
                            <a href={`tel:${PHONE_TEL}`} className="hover:text-aegean-300">{PHONE}</a>
                        </li>
                        <li className="flex items-start gap-2">
                            <MapPin size={14} className="mt-1 shrink-0" />
                            <a href={MAPS_LINK} target="_blank" rel="noreferrer" className="hover:text-aegean-300">
                                {ADDRESS}<br />Lemnos, Greece
                            </a>
                        </li>
                        <li className="flex items-start gap-2">
                            <Mail size={14} className="mt-1 shrink-0" />
                            <a href={`mailto:${EMAIL}`} className="hover:text-aegean-300 break-all">{EMAIL}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
                © {new Date().getFullYear()} AMOS Beach Bar — {t("footer.rights")}
            </div>
        </footer>
    );
};

export default Footer;
